import type { Element } from 'react'
import React from 'react'
import { MenuItem } from './MenuItem'
import type { IntlShape } from 'react-intl'
import { injectIntl } from 'react-intl'
import { media } from 'app/assets/styles'
import styled from 'styled-components'
import { TileSquareGrid } from 'app/common/tile-square'
import type { BreadcrumbElement } from 'app/common/breadcrumb'
import { eventsDefinitions } from 'shared/store/metadata'

type Props = {
    tiles: Array<any>,
    descriptionKey: string,
    titleKey: string,
    breadcrumbArray?: Array<BreadcrumbElement>,
    breadcrumbKey?: string,
    propRoute: string,
    intl: IntlShape,
    hasTileText?: boolean,
    children?: Element<any>,
    topChild?: Element<any>,
    isCategories?: boolean
}

const MenuWithTiles = injectIntl((props: Props) => {
    const {
        tiles,
        intl,
        descriptionKey,
        titleKey,
        breadcrumbArray,
        breadcrumbKey,
        propRoute,
        hasTileText,
        children,
        topChild,
        isCategories = false
    } = props
    const breadcrumb = breadcrumbArray
        ? breadcrumbArray
        : [
              {
                  title: intl.formatMessage({
                      id: breadcrumbKey
                  })
              }
          ]
    const title = intl.formatMessage({ id: titleKey })
    const description = intl.formatMessage({
        id: descriptionKey
    })
    const route = intl.formatMessage({ id: propRoute })
    const tilesList = tiles
        .filter(category => category.pushed)
        .map(category => {
            return {
                actionUrl: `${route}/${category.routeId}`,
                image: category.image,
                name: category.title,
                backgroundColor: category.backgroundColor,
                color: category.color ? category.color : 'black',
                type: 'category',
                tileText: category.tileText,
                meta: {
                    ...eventsDefinitions['CATEGORY_CLICK'],
                    event_action: category.title
                }
            }
        })
    const menuProps = {
        breadcrumb,
        title,
        description,
        topChild
    }
    return (
        <MenuItem {...menuProps}>
            <TileSquareContainer>
                {topChild}
                <TileSquareGrid
                    justify="flex-start"
                    tiles={tilesList}
                    hasTileText={hasTileText}
                    isCategories={isCategories}
                />
                {children}
            </TileSquareContainer>
        </MenuItem>
    )
})

const TileSquareContainer = styled.div`
    width: 100%;
    margin-top: 40px;
    min-height: 400px;
    ${media.medium`
        min-height: 900px;
    `};
`

export { MenuWithTiles }
